import { useState, useEffect } from "react";
import axios from "axios";
import CountUp from "react-countup";
import './visitorcount.css';

const VisitorCounter = () => {
  const [visitorData, setVisitorData] = useState({ message: "", count: null });
  const [isVisitorIncremented, setIsVisitorIncremented] = useState(false);

  useEffect(() => {
    const fetchVisitorCount = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_VISITOR_COUNT_API_URL}/api/visitor`);
        setVisitorData(response.data);

        if (!localStorage.getItem("hasVisited") && !isVisitorIncremented) {
          await handleVisit();
          setIsVisitorIncremented(true);
        }
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    };

    fetchVisitorCount();
  }, [isVisitorIncremented]);

  const handleVisit = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_VISITOR_COUNT_API_URL}/api/visitor`);
      const response = await axios.get(`${process.env.REACT_APP_VISITOR_COUNT_API_URL}/api/visitor`);
      setVisitorData(response.data);
      localStorage.setItem("hasVisited", "true");
    } catch (error) {
      console.error("Error incrementing visitor count:", error);
    }
  };

  // Function to add Indian-style comma formatting
  const formatNumberWithIndianCommas = (num) => {
    return num.toLocaleString('en-IN'); // Uses proper Indian formatting like 3,44,457
  };

  const getOrdinalSuffix = (num) => {
    if (!num) return "";
    let lastDigit = num % 10,
        lastTwoDigits = num % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) return "th";
    if (lastDigit === 1) return "st";
    if (lastDigit === 2) return "nd";
    if (lastDigit === 3) return "rd";
    return "th";
  };

  return (
    <div className="visitorCount">
      <p>{visitorData.message}</p>
      {visitorData.count !== null ? (
        <p >
          You are the{" "}
          <CountUp 
            start={0} 
            end={visitorData.count} 
            duration={2.5} 
            formattingFn={formatNumberWithIndianCommas} // 🎯 Directly format number during animation
            className="flicker-text"
          />
          <sup>{getOrdinalSuffix(visitorData.count)}</sup> <span className="visitor-block">visitor</span>
        </p>
      ) : (
        <span style={{textAlign: "center", display: "flex", justifyContent: "center"}}> Loading...</span>
      )}
    </div>
  );
};

export default VisitorCounter;
